import { createMutateReducer } from "common/helpers/reducer";
import * as action from "../actions/kkmGroupTransactionListAction";

const initialState = {
	isLoading: true,
	isNoItems: false,

	scroll: {
		isLoading: false,
		size: 20,
		page: 0,
		totalElements: 0
	},
	search: {
		isLoading: false,
		value: ""
	},
	filter: {
		isLoading: false,
		by: "",
		start: "",
		end: ""
	},
	sort: {
		field: "checkOutDate",
		order: "asc"
	},
	itemsActions: {},

	kkmGroupId: "",
	company: {},
	items: []
};
const actionHandlers = {
	// Initialize
	[action.initKkmGroupTransactionList.request]: createMutateReducer((draft, { kkmGroupId }) => {
		draft.isLoading = true;
		draft.isNoItems = false;

		draft.scroll.isLoading = false;
		draft.scroll.page = 0;
		draft.scroll.totalElements = 0;

		draft.search.isLoading = false;
		draft.search.value = "";

		draft.itemsActions = {};

		draft.filter.isLoading = false;

		draft.kkmGroupId = kkmGroupId;
		draft.company = {};
		draft.items = [];
	}),
	[action.initKkmGroupTransactionList.success]: createMutateReducer((draft, { group, items, totalElements }) => {
		draft.isLoading = false;
		draft.isNoItems = !items.length;

		draft.scroll.totalElements = totalElements;

		draft.group = group;
		draft.items = items;
	}),
	[action.initKkmGroupTransactionList.error]: createMutateReducer(draft => {
		draft.isLoading = false;
		draft.isNoItems = true;
	}),

	// Scroll
	[action.scrollKkmGroupTransactionList.request]: createMutateReducer(draft => {
		draft.scroll.isLoading = true;
	}),
	[action.scrollKkmGroupTransactionList.success]: (state, { items, page }) => ({
		...state,
		scroll: {
			...state.scroll,
			isLoading: false,
			page
		},
		items: [...state.items, ...items]
	}),
	[action.scrollKkmGroupTransactionList.error]: createMutateReducer(draft => {
		draft.scroll.isLoading = false;
	}),

	// Search
	[action.searchKkmGroupTransactionList.request]: createMutateReducer((draft, { value }) => {
		draft.search.isLoading = true;
		draft.search.value = value;
	}),
	[action.searchKkmGroupTransactionList.success]: createMutateReducer((draft, { items, totalElements }) => {
		draft.scroll.page = 0;
		draft.scroll.totalElements = totalElements;

		draft.search.isLoading = false;

		draft.items = items;
	}),
	[action.searchKkmGroupTransactionList.error]: createMutateReducer(draft => {
		draft.search.isLoading = false;
	}),

	// Filter
	[action.filterKkmGroupTransactionList.request]: createMutateReducer((draft, params, state) => {
		draft.filter = {
			isLoading: true,
			...state.filter,
			...params
		};
	}),
	[action.filterKkmGroupTransactionList.success]: createMutateReducer((draft, { items, totalElements }) => {
		draft.scroll.page = 0;
		draft.scroll.totalElements = totalElements;

		draft.filter.isLoading = false;

		draft.items = items;
	}),
	[action.filterKkmGroupTransactionList.error]: createMutateReducer(draft => {
		draft.filter.isLoading = false;
	}),

	[action.sortKkmGroupTransactionList.request]: createMutateReducer((draft, { field, order }) => {
		draft.filter.isLoading = true;
		draft.sort = { field, order };
	}),
	[action.sortKkmGroupTransactionList.success]: createMutateReducer((draft, { items, totalElements }) => {
		draft.scroll.page = 0;
		draft.scroll.totalElements = totalElements;

		draft.filter.isLoading = false;

		draft.items = items;
	}),
	[action.sortKkmGroupTransactionList.error]: createMutateReducer(draft => {
		draft.filter.isLoading = false;
	}),

	// Show detail transaction
	[action.showDetailKkmGroupTransactionList]: createMutateReducer((draft, { requestId }, state) => {
		draft.itemsActions[requestId] = state.itemsActions[requestId] || {};
		draft.itemsActions[requestId].isOpen = !draft.itemsActions[requestId].isOpen;
	})
};

export { initialState, actionHandlers };
export default createReducer => createReducer(initialState, actionHandlers);
